import React, { useState, useEffect } from "react";
import { getToken, base_url } from "../../config/config";

const ContactPersonForm = () => {
  const [firms, setFirms] = useState([]);
  const [formData, setFormData] = useState({
    firmaId: "",
    name: "",
    email: "",
  });
  const [status, setStatus] = useState({
    message: "",
    type: "", // 'success' or 'error'
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchFirms();
  }, []);

  const fetchFirms = async () => {
    try {
      const response = await fetch(`${base_url}/v1/getFirma`);
      const data = await response.json();
      setFirms(data.data);
    } catch (error) {
      console.error("Error fetching firms:", error);
      setStatus({
        message: "Failed to load firms. Please try again later.",
        type: "error",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ message: "", type: "" });

    try {
      const response = await fetch(
        `${base_url}/v1/bestellung/createContactPerson`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        },
      );

      if (!response.ok) throw new Error("Failed to create contact person");

      const result = await response.text();
      setStatus({
        message: "Contact person created successfully!",
        type: "success",
      });
      setFormData({ firmaId: "", name: "", email: "" });
    } catch (error) {
      console.error("Error:", error);
      setStatus({
        message: "Failed to create contact person. Please try again.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className='min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-md mx-auto bg-white rounded-lg shadow-md p-8'>
        <h2 className='text-2xl font-bold text-gray-900 mb-6'>
          Create Contact Person
        </h2>

        {status.message && (
          <div
            className={`mb-4 p-4 rounded ${
              status.type === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}>
            {status.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className='space-y-6'>
          <div>
            <label
              htmlFor='firmaId'
              className='block text-sm font-medium text-gray-700'>
              Company
            </label>
            <select
              id='firmaId'
              name='firmaId'
              value={formData.firmaId}
              onChange={handleChange}
              required
              className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white py-2 px-3'>
              <option value=''>Select a company</option>
              {firms.map((firm) => (
                <option key={firm._id} value={firm._id}>
                  {firm.bezeichnung}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label
              htmlFor='name'
              className='block text-sm font-medium text-gray-700'>
              Name
            </label>
            <input
              type='text'
              id='name'
              name='name'
              value={formData.name}
              onChange={handleChange}
              required
              className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500'
            />
          </div>

          <div>
            <label
              htmlFor='email'
              className='block text-sm font-medium text-gray-700'>
              Email
            </label>
            <input
              type='email'
              id='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              required
              className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500'
            />
          </div>

          <button
            type='submit'
            disabled={loading}
            className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            }`}>
            {loading ? "Creating..." : "Create Contact Person"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactPersonForm;
